// Rentas de salón, ensayos y privadas: ocupan el salón (deben verse para no
// agendar encima) pero no son clases operativas con cupo/inscripciones.
// En calendarios se pintan como capa secundaria (gris rayado) y son ocultables.
export const isNonOperative = (name?: string | null) => /renta|ensayo|privada/i.test(name || '');

/** Registro de UN SOLO DÍA (inicio = fin): así se guarda una renta o ensayo desde el 8-oct-2026 (Karla:
 *  «Frank» sin la palabra «renta» salía como clase con cupo 0 y el filtro no lo ocultaba). */
export const isOneDay = (b: { start_date?: string | null; end_date?: string | null }) =>
  !!b.start_date && b.start_date.slice(0, 10) === (b.end_date || '').slice(0, 10);

/** Renta / ensayo / privada: por el nombre o porque es de un solo día. */
export const isRentaOEnsayo = (b: { name?: string | null; start_date?: string | null; end_date?: string | null }) =>
  isNonOperative(b.name) || isOneDay(b);
